//region 1. Platform Libraries
import { assert } from 'chai';
//endregion

//region 2. Project Libraries
import { isValidStreamIndex } from './Utils';
//endregion

//region T. Tests
describe('isValidStreamIndex', () => {
        it('should pass if 0', () => assert.equal(true, isValidStreamIndex(0)));
});
//endregion
